/**
 * Clustering dashboard — URL-driven view switcher.
 *
 * Mirrors the SimilarityDashboard pattern: a single page component that
 * renders different sub-views based on the current route params.
 *
 *   /clustering                                   → ProjectsView
 *   /clustering/:projectId                        → BatchesView
 *   /clustering/:projectId/create                 → BatchesView + CreateBatchView modal
 *   /clustering/:projectId/batches/:batchId       → BatchDetailView
 */

import { useParams, useLocation } from 'react-router-dom';
import { ProjectsView } from '../../components/Clustering/Projects/ProjectsView';
import { BatchesView } from '../../components/Clustering/Batches/BatchesView';
import { CreateBatchView } from '../../components/Clustering/Create/CreateBatchView';
import { BatchDetailView } from '../../components/Clustering/BatchDetail/BatchDetailView';

export default function ClusteringDashboard() {
  const { projectId, batchId } = useParams<{ projectId?: string; batchId?: string }>();
  const { pathname } = useLocation();

  if (projectId && batchId) {
    return <BatchDetailView projectId={projectId} batchId={batchId} />;
  }
  // CreateBatchView is a modal now, so the batches list stays mounted behind
  // it instead of the whole page being swapped out (matching the JobCreator /
  // Word Cloud create-flow pattern).
  if (projectId && pathname.endsWith('/create')) {
    return (
      <>
        <BatchesView projectId={projectId} />
        <CreateBatchView projectId={projectId} />
      </>
    );
  }
  if (projectId) {
    return <BatchesView projectId={projectId} />;
  }
  return <ProjectsView />;
}
